require('../../node_modules/assets/js/es6/pklib-es6.js');
window.PkVue = require('../../node_modules/assets/vue-templates/vue-data-components.js');
window.PkVue = require('../../node_modules/assets/vue-templates/vue-components.js');

//import DropInPlace from '../../node_modules/assets/vue-templates/drop-inplace.vue';
//window.Vue.component('drop-inplace',DropInPlace);
import PkModal from '../../node_modules/assets/vue-templates/pk-modal.vue';
window.Vue.component('pk-modal',PkModal);

require('../../node_modules/assets/js/es6/pk-axios-init.js');
require('../resources/vues/mentalhealth-vue-components.js');













